// components/RequireRole.jsx
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

export default function RequireRole({ allowed }) {
  const { role }     = useSelector(s => s.user.userData ?? {});   // “Root”, “Admin”, etc.
  const isLoading    = useSelector(s => s.user.isLoading);

  /* While we’re still fetching the profile you can show a spinner */
  if (isLoading) return <div>Loading…</div>;

  /* Not signed in → kick to login */
  if (!role) return <Navigate to="/signin" replace />;

  /* Signed in but wrong role → show 403 page */
  if (!allowed.includes(role))
    return <Navigate to="/unauthorized" replace />;   // or <Forbidden />

  /* Happy path: render the child routes */
  return <Outlet />;
}
